export const DetailCardsKey = {
  campaign: 'campaign',
  billing: 'billing',
  editorial: 'editorial',
  conversionTracking: 'conversionTracking',
  bidding: 'bidding',
  assetGroup: 'assetGroup',
};
